import { CrewErrorBoundary } from 'components/functions/crewErrorBoundary'
import { TaskListToolbar } from 'features/task/components/taskListPage/components/taskListToolbar/taskListToolbar'
import { FC, memo } from 'react'
import { TaskListPanel } from './components/taskListPanel/taskListPanel'

export const TaskListPage: FC = memo(() => {
  return (
    <div className="min-h-0 flex-1 flex flex-col grow w-full">
      <div className="min-h-0 flex flex-col gap-4 p-2">
        <CrewErrorBoundary>
          <TaskListToolbar />
        </CrewErrorBoundary>
        <CrewErrorBoundary>
          <TaskListPanel />
        </CrewErrorBoundary>
      </div>
    </div>
  )
})
